import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-sm"></i>
                </div>
                <span className="text-lg font-bold text-background-50 font-heading">蓝莓视频</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                蓝莓视频是水果视频聚合平台，提供与香蕉视频、蜜桃视频、西瓜视频、樱桃视频同类型的高清影视资源，免费在线观看，不缓冲流畅播放。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/dianshiju" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电视剧</Link></li>
                <li><Link to="/category/dianying" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">电影</Link></li>
                <li><Link to="/category/dongman" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">动漫</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">水果视频推荐</h4>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-background-400">香蕉视频</span></li>
                <li><span className="text-sm text-background-400">蜜桃视频</span></li>
                <li><span className="text-sm text-background-400">西瓜视频</span></li>
                <li><span className="text-sm text-background-400">樱桃视频</span></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
              </ul>
              <div className="flex gap-3 mt-5">
                <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-300 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-300 text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-background-300 text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 蓝莓视频 LanMei.Video - 高清免费在线观看水果视频推荐平台
            </p>
            <p className="text-xs text-background-600">
              本站内容仅供学习交流，不存储任何视频文件
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}